import { IconFieldDesignTokens } from '@primeuix/themes/types/iconfield';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/iconfield/index.ts
const icf = componentCommon.iconfield;

export const IconFieldTelekomDT: IconFieldDesignTokens = {
  icon: {
    color: t(icf.icon.color),
  },
};
